module.exports = __webpack_public_path__ + "img/gywm01.eeda71e9.png";